module.exports = __webpack_public_path__ + "img/cl.bf0e1932.jpg";